export default "__VITE_ASSET__uyrgAYcA__"